import merchantProvider from "src/providers/merchant-provider";
import type { Merchant } from "src/types";
import { create } from "zustand";
import { useShallow } from "zustand/shallow";

type MerchantStore = {
	merchant: Merchant | undefined;
	setMerchant: (merchant: Merchant | undefined) => void;
	getMerchant: (merchantId: string) => Promise<Merchant | undefined>;
};

const useMerchantStore = create<MerchantStore>((set) => ({
	merchant: undefined,
	setMerchant: (merchant) => set({ merchant }),
	getMerchant: async (merchantId: string) => {
		const merchant = await merchantProvider.showMerchant(merchantId);
		set({ merchant });
		return merchant;
	},
}));

const useSharedMerchant = () =>
	useMerchantStore(
		useShallow((s) => ({
			merchant: s.merchant,
			getMerchant: s.getMerchant,
		})),
	);

export default useSharedMerchant;
